const accessibility = {
  accessibilityClassName: 'accessibility',

  init() {
    document.addEventListener('keydown', (event) => this.handleKeyDown(event));
    document.addEventListener('mousedown', () => this.handleMouseDown());
  },

  handleKeyDown(event) {
    if (event.keyCode === 9) {
      document.body.classList.add(this.accessibilityClassName);
    }
  },

  handleMouseDown() {
    document.body.classList.remove(this.accessibilityClassName);
  },
};

export default accessibility;



// WEBPACK FOOTER //
// ./scripts/modules/accessibility.js